<template>
  <div id="container">
    <v-container wrap>
      <v-dialog v-model="enable" v-if="ggs" max-width="320" style="color:black">
        <v-card>
          <div class="custom_box">
            <div class="custom_box-top">
              <v-card-title class="headline" style="padding: 10px 15px;">
                Sugerencia de salidas
              </v-card-title>
            </div>
            <div class="custom_box-middle">
              <v-card-text>
                En la última entrega que realizaste, seleccionaste:
                <ul v-for="gg in groupsByLevelOnUi">
                  <li>{{ gg.levelName }}</li>
                  <ul>
                    <li v-for="group in gg.groups">
                      {{ group.gradeGroupName }}
                    </li>
                  </ul>
                </ul>
              </v-card-text>
            </div>
            <div class="custom_box-bottom">
              <p>
                ¿Deseas seleccionarlos nuevamente?
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat="flat" @click="close">Cancelar</v-btn>
                <v-btn color="primary darken-1" flat="flat" @click="handleClick">SI, CONTINUAR</v-btn>
              </v-card-actions>
            </div>
          </div>
        </v-card>
        <!-- <v-card>
          <v-card-title class="headline">
            Sugerencia de salidas
          </v-card-title>
          <v-card-text>
            En última entrega que realizaste, seleccionaste:
            <ul v-for="gg in ggs">
              <li>{{ gg.levelName }}</li>
              <ul>
                <li v-for="group in gg.groups">
                  {{ group.gradeGroupName }}
                </li>
              </ul>
            </ul>
            <p>
              ¿Deseas seleccionarlos nuevamente?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="close">Cancelar</v-btn>
            <v-btn color="primary darken-1" flat="flat" @click="handleClick">SI, CONTINUAR</v-btn>
          </v-card-actions>
        </v-card> -->
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { GradeGroupList } from './utils.js'
export default {
  props: ["value"],
  data() {
    return {
      enable: false,
      gp: [],
      ggs: "",
      groupsByLevelOnUi: [],
    };
  },
  watch: {
    value() {
      this.enable = this.value;
    },
    
  },
  mounted(){
    this.lastGroup();
  },
  methods: {
    _groupGradeByLevel(arrayGradeGroup = []) {
        const temporalObj = {}

        for (const obj of arrayGradeGroup) {
          if (obj.grade === '' || obj.group === '') {
            continue
          }

          if (temporalObj[obj.levelId] === undefined) {
            temporalObj[obj.levelId] = {
              levelName: obj.levelName,
              levelId: obj.levelId,
              groups: []
            }
          }

          temporalObj[obj.levelId].groups.push(obj)
        }

        return Object.values(temporalObj).flat()
    },
    close() {
      this.$emit("input", false);
    },
    handleClick() {
      this.$emit("click", this.groups);
      this.$emit("input", false);
    },
    lastGroup(){
      this.$store
        .dispatch("request/getLastGroups")
        .then(response => {
          this.groups = response.data;
          this.gp = new Array();
          for (let index = 0; index < this.groups.length; index++) {
            this.ggs = this.ggs + this.groups[index].levelName+": " + this.groups[index].grade + this.groups[index].group + ", ";
            let aux = { 
              id: this.groups[index].id,
              attenders: 0,
              nStudents: 0,
              grade:  this.groups[index].grade,
              group: this.groups[index].group,
              levelId: this.groups[index].levelId
            }
            this.gp.push(aux);
          };
          this.groups = this.gp;
          
          this.groupsByLevelOnUi = this._groupGradeByLevel(GradeGroupList(response.data))
          if (this.groups=="") {
            this.close();
          }
        })
        .catch(error => {
          console.log(error);
          this.close();
        });
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.close();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },
};
</script>
 
<style scoped>
.custom_box{
  position: relative;
  height: 100%;
}
.custom_box-top{
}
.custom_box-middle{
  max-height: 500px;
  overflow: scroll;
  position: relative;
}
.custom_box-bottom{
  width: 100%;
}
.custom_box-bottom p{
  padding: 0 15px;
}
</style>
